<eb-generic-page-stepper
  *ngIf="showStepper && formConfig.steps.length > 1"
  [steps]="pageSteps"
  [activeStep]="activeStep"
  (changeStep)="onStepChange($event)"
  [attr.supports-mobile]="true"
  [attr.position]="'top'"
></eb-generic-page-stepper>

<h2 *ngIf="!hideTitle">{{ toDottedString(context) + '.pageTitle' | cxTranslate }}</h2>

<form [class]="'eb-form ' + toDashedString(context)" [formGroup]="form" (ngSubmit)="onFormSubmit()">
  <section class="eb-form__step" *ngFor="let step of formConfig.steps; let index = index">
    <ng-container *ngIf="index === activeStep">
      <h3 *ngIf="!step.hideTitle">
        {{ toDottedString(context) + '.step.' + index | cxTranslate }}
      </h3>
      <ng-template
        *ngIf="step.elements"
        [ngTemplateOutlet]="elementsRenderer"
        [ngTemplateOutletContext]="{
          elements: step.elements,
          controls: form,
          path: ''
        }"
      ></ng-template>
      <div class="eb-form__step-buttons">
        <button
          *ngIf="activeStep > 0"
          class="eb-form__step-button eb-form__step-button--previous"
          (click)="onPreviousStep()"
          data-cy="step-prev"
        >
          {{ toDottedString(context) + '.step.button.previous' | cxTranslate }}
        </button>
        <button
          *ngIf="activeStep < formConfig.steps.length - 1"
          class="eb-form__step-button eb-form__step-button--next"
          (click)="onNextStep()"
          [attr.disabled]="
            (currentStepValid$ | async) || formConfig.stepsAlwaysEnabled ? undefined : true
          "
          data-cy="step-next"
        >
          {{ toDottedString(context) + '.step.button.next' | cxTranslate }}
        </button>
        <button
          *ngIf="activeStep === formConfig.steps.length - 1"
          class="eb-form__step-button eb-form__step-button--submit"
          [attr.disabled]="
            !submitting && ((currentStepValid$ | async) || formConfig.stepsAlwaysEnabled)
              ? undefined
              : true
          "
          type="submit"
          data-cy="step-submit"
        >
          {{ toDottedString(context) + '.step.button.submit' | cxTranslate }}
        </button>
        <ng-content></ng-content>
      </div>
    </ng-container>
  </section>
</form>

<ng-template #elementsRenderer let-elements="elements" let-controls="controls" let-path="path">
  <div class="eb-form__elements">
    <ng-container *ngFor="let element of elements">
      <ng-template
        *ngIf="
          ['group', 'field', 'component'].includes(element.type) &&
          (getState((path ? path + '.' : '') + element.name) | async)
        "
        [ngTemplateOutlet]="
          (element.type === 'group' && groupRenderer) ||
          (element.type === 'field' && fieldRenderer) ||
          (element.type === 'component' && componentRenderer)
        "
        [ngTemplateOutletContext]="{
          element: element,
          control: (element.type !== 'component' && controls?.get(element.name)) || null,
          path: path ? path + '.' + element.name : element.name,
          disabled: getState((path ? path + '.' : '') + element.name, 'disable', false) | async
        }"
      ></ng-template>
    </ng-container>
  </div>
</ng-template>

<ng-template #groupRenderer let-groupConfig="element" let-formGroup="control" let-path="path">
  <div
    [class]="
      'eb-form__group' +
      ' eb-form__group--' +
      toDashedString(groupConfig.name) +
      (groupConfig.expandable
        ? ' eb-form__group--expandable' +
          ' eb-form__group--' +
          ((getExpandedState(path, groupConfig) | async) ? 'expanded' : 'collapsed')
        : '')
    "
    [formGroup]="formGroup"
    [attr.data-cy]="toCamelCasePath(path)"
  >
    <h3
      *ngIf="!groupConfig.hideTitle"
      [class]="groupConfig.expandable ? ' eb-form__group--expandable' : ''"
      (click)="toggleExpandedState(path)"
    >
      {{ toCamelCaseString(context) + '.' + path + '.header' | cxTranslate }}
    </h3>
    <ng-template
      *ngIf="
        groupConfig.elements &&
        (!groupConfig.expandable || (getExpandedState(path, groupConfig) | async))
      "
      [ngTemplateOutlet]="elementsRenderer"
      [ngTemplateOutletContext]="{
        elements: groupConfig.elements,
        controls: formGroup,
        path: path
      }"
    ></ng-template>
  </div>
</ng-template>

<ng-template
  #fieldRenderer
  let-fieldConfig="element"
  let-control="control"
  let-path="path"
  let-disabled="disabled"
>
  <eb-form-field
    *ngIf="fieldConfig.fieldType !== 'component'"
    [class]="'eb-form__field eb-form__field--' + context + '-' + toDashedString(fieldConfig.name)"
    [context]="context"
    [fieldConfig]="fieldConfig"
    [control]="control"
    (changing)="onFieldChanging()"
    (next)="onNext()"
    [path]="path"
    [disabled]="disabled"
  ></eb-form-field>
  <ng-template
    *ngIf="fieldConfig.fieldType === 'component'"
    [cxOutlet]="render(fieldConfig, path)"
    [cxOutletContext]="{
      fieldConfig: fieldConfig,
      control: control || null,
      path: path,
      context: context,
      disabled: disabled
    }"
  >
  </ng-template>
</ng-template>

<ng-template #componentRenderer let-config="element" let-control="control" let-path="path">
  <div class="eb-form__component">
    <ng-template
      [cxOutlet]="render(config, path)"
      [cxOutletContext]="{
        config: config,
        control: control || null,
        path: path
      }"
    >
    </ng-template>
  </div>
</ng-template>

<eb-generic-page-stepper
  *ngIf="showStepper && formConfig.steps.length > 1"
  [steps]="pageSteps"
  [activeStep]="activeStep"
  (changeStep)="onStepChange($event)"
  [attr.supports-mobile]="true"
  [attr.position]="'bottom'"
></eb-generic-page-stepper>
